// extracted by mini-css-extract-plugin
module.exports = {"list":"Items_list__3yV-g","card":"Items_card__uFPJ1","loader":"Items_loader__SL6ut"};